import { render } from "./Programs.vue?vue&type=template&id=6f244570&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import "./Programs.vue?vue&type=style&index=0&id=6f244570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f244570"]])

export default __exports__